import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";

const Paginator = ({ currentPage, totalPages, onPageChange }) => {
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    if (totalPages <= 1) return null;

    return (
        <div className="mt-6 flex items-center justify-center gap-2 p-2">
            {/* back */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="border-slate-200 text-slate-500 hover:border-slate-800 hover:text-slate-800 flex h-9 w-9 items-center justify-center rounded-full border bg-white transition-all disabled:cursor-not-allowed disabled:opacity-40"
            >
                <FontAwesomeIcon
                    className="h-4 w-4 text-gray-700"
                    icon={faChevronLeft}
                />
            </button>

            {/* numbers */}
            <div className="flex gap-1.5">
                {pages.map((page) => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`h-9 w-9 rounded-lg text-sm font-medium transition-all ${
                            currentPage === page
                                ? "bg-gray-700 text-white"
                                : "text-slate-500 hover:bg-slate-100 border-transparent border"
                        }`}
                    >
                        {page}
                    </button>
                ))}
            </div>

            {/* next */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="border-slate-200 text-slate-500 hover:border-slate-800 hover:text-slate-800 flex h-9 w-9 items-center justify-center rounded-full border bg-white transition-all disabled:cursor-not-allowed disabled:opacity-40"
            >
                <FontAwesomeIcon
                    className="h-4 w-4 text-gray-700"
                    icon={faChevronRight}
                />
            </button>
        </div>
    );
};

export default Paginator;
